import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { getHourFeed } from '@/service/purchase/reportAggregate';
export default function useHourFeed(params) {
  var feedingData = ref([]);
  var getHourFeedAsync = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            feedingData.value.splice(0);
            _context.next = 3;
            return getHourFeed(params.value);
          case 3:
            data = _context.sent;
            feedingData.value = data.list;
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getHourFeedAsync() {
      return _ref.apply(this, arguments);
    };
  }();
  var dayData = computed(function () {
    var _feedingData$value$0$, _feedingData$value$, _feedingData$value$0$2, _feedingData$value$2;
    var colors = ['#82A3FF', '#5AC57F', '#EEC324'];
    var lineData = (_feedingData$value$0$ = (_feedingData$value$ = feedingData.value[0]) === null || _feedingData$value$ === void 0 ? void 0 : _feedingData$value$.value.map(function (item, index) {
      return feedingData.value.map(function (iten) {
        colors[index] = iten.value[index].color;
        return iten.value[index];
      });
    })) !== null && _feedingData$value$0$ !== void 0 ? _feedingData$value$0$ : [];
    var xLabels = feedingData.value.map(function (item) {
      return item.time;
    });
    var legendData = (_feedingData$value$0$2 = (_feedingData$value$2 = feedingData.value[0]) === null || _feedingData$value$2 === void 0 ? void 0 : _feedingData$value$2.value.map(function (item) {
      return item.supplier;
    })) !== null && _feedingData$value$0$2 !== void 0 ? _feedingData$value$0$2 : [];
    return {
      xLabels: xLabels,
      lineData: lineData,
      legendData: legendData,
      colors: colors,
      grid: {
        left: 55,
        top: 10,
        bottom: 120,
        right: 20
      },
      legendBottom: 2,
      customTooltip: true,
      tooptipFormatter: function tooptipFormatter(params1) {
        var res = "\n                  <div >\n                    <div class=\"flex align-center\">\n                      <span class=\"ml-2\">".concat(params1[0].axisValue, "</span>\n\n                    </div>\n                  ");
        params1.forEach(function (item) {
          res += "\n                    <div >\n                      ".concat(item.marker, "\n                      <span style=\"font-size: 12px;\">").concat(item.seriesName, "</span>\n                      <span style=\"font-weight:bold;font-size: 12px;\">").concat(item.value).concat(params.value.type === 0 ? '吨' : params.value.type === 1 ? '车' : '万元', "</span>\n                    </div>\n                  ");
        });
        res += '</div>';
        return res;
      }
    };
  });
  return [dayData, getHourFeedAsync];
}